// Make sure to run: npm install @formspree/react
import React from 'react';
import { useForm, ValidationError } from '@formspree/react';

function Contact() {
  const [state, handleSubmit] = useForm("mnnvrnbk");

  if (state.succeeded) {
    return (
      <div
        className="text-center py-16"
        data-aos="zoom-in"
      >
        <h2 className="text-2xl font-semibold text-green-600">✅ Message Sent!</h2>
        <p className="text-gray-700 mt-2">Thanks for reaching out. I'll get back to you soon!</p>
      </div>
    );
  }

  return (
    <section
      id="contact"
      className="py-20 px-6 bg-gray-100"
      data-aos="fade-up" // ✅ Animate on scroll
    >
      <div
        className="max-w-2xl mx-auto bg-white p-8 shadow-xl rounded-lg"
        data-aos="zoom-in"
        data-aos-delay="100"
      >
        <h2 className="text-3xl font-bold text-center mb-6 text-blue-600">
          Contact Me
        </h2>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div data-aos="fade-up" data-aos-delay="200">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">Your Email</label>
            <input
              id="email"
              type="email"
              name="email"
              required
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              placeholder="you@example.com"
            />
            <ValidationError prefix="Email" field="email" errors={state.errors} />
          </div>

          <div data-aos="fade-up" data-aos-delay="300">
            <label htmlFor="message" className="block text-sm font-medium text-gray-700">Your Message</label>
            <textarea
              id="message"
              name="message"
              rows="4"
              required
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              placeholder="Write your message here..."
            />
            <ValidationError prefix="Message" field="message" errors={state.errors} />
          </div>

          <div data-aos="fade-up" data-aos-delay="400">
            <button
              type="submit"
              disabled={state.submitting}
              className="w-full py-2 px-4 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 transition"
            >
              {state.submitting ? "Sending..." : "Send Message"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default Contact;
